module.exports = __webpack_public_path__ + "static/media/mountains.07ad16a9.svg";